import React from "react";
import PropTypes from "prop-types";

const StyledTextCell = ({ value, getValue, style }) => (
  <div style={style}>{getValue(value)}</div>
);

StyledTextCell.propTypes = {
  value: PropTypes.string,
  getValue: PropTypes.func,
  style: PropTypes.object
};

StyledTextCell.defaultProps = {
  getValue: (val) => val,
  style: {}
};

export default StyledTextCell;
